(function () {
  function initBadges(container) {
    var badges = container.querySelectorAll('[data-best-seller-badge]:not(.is-initialized)');

    badges.forEach(function (badge) {
      badge.classList.add('is-initialized');

      var card = badge.closest(
        '.product-grid-item, .bundle-creator-new__product, .new-product-grid-item, .swiper-slide'
      );
      if (!card) return;

      var img =
        card.querySelector('.new-pc-img') ||
        card.querySelector('.bundle-creator-new__product-img') ||
        card.querySelector('.new-product-grid-item-images img:first-of-type') ||
        card.querySelector('a.product-image img');
      if (!img) return;

      function showBadge() {
        badge.classList.add('is-visible');
      }

      if (img.complete && img.naturalWidth > 0) {
        showBadge();
      } else {
        img.addEventListener('load', showBadge);
        img.addEventListener('error', showBadge);
      }
    });
  }

  function init() {
    initBadges(document);

    var collectionGrid = document.querySelector('.collection-grid-wrap');
    if (collectionGrid) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length) {
            initBadges(collectionGrid);
          }
        });
      });

      observer.observe(collectionGrid, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
